import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Inject admin bearer token if present
api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem("dompryce_admin_token");
  if (adminToken && config.url && config.url.startsWith("/admin")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${adminToken}`;
  }
  return config;
});

export const endpoints = {
  domainCheck: (name) => api.get(`/domain/check`, { params: { name } }),
  domainCompare: (name) => api.get(`/domain/compare`, { params: { name } }),
  registrars: () => api.get(`/domain/registrars`),
  generateNames: (body) => api.post(`/ai/generate-names`, body),
  aiQuota: () => api.get(`/ai/quota`),
  // billing
  billingMe: () => api.get(`/billing/me`),
  createOrder: (currency) => api.post(`/billing/razorpay/order`, { currency }),
  verifyPayment: (body) => api.post(`/billing/razorpay/verify`, body),
  premiumDomains: (category) => api.get(`/premium-domains`, { params: category ? { category } : {} }),
  insights: () => api.get(`/insights`),
  ads: (slot) => api.get(`/ads`, { params: slot ? { slot } : {} }),
  // auth
  authMe: () => api.get(`/auth/me`),
  googleCallback: (session_id) => api.post(`/auth/google/callback`, { session_id }),
  logout: () => api.post(`/auth/logout`),
  // user data
  savedList: () => api.get(`/saved-domains`),
  savedCreate: (body) => api.post(`/saved-domains`, body),
  savedDelete: (id) => api.delete(`/saved-domains/${id}`),
  watchlists: () => api.get(`/watchlists`),
  watchlistCreate: (body) => api.post(`/watchlists`, body),
  watchlistDelete: (id) => api.delete(`/watchlists/${id}`),
  // admin
  adminLogin: (body) => api.post(`/auth/admin/login`, body),
  adminLogout: () => api.post(`/auth/admin/logout`),
  adminAds: () => api.get(`/admin/ads`),
  adminAdCreate: (body) => api.post(`/admin/ads`, body),
  adminAdUpdate: (id, body) => api.put(`/admin/ads/${id}`, body),
  adminAdDelete: (id) => api.delete(`/admin/ads/${id}`),
  adminPremiumCreate: (body) => api.post(`/admin/premium-domains`, body),
  adminPremiumUpdate: (id, body) => api.put(`/admin/premium-domains/${id}`, body),
  adminPremiumDelete: (id) => api.delete(`/admin/premium-domains/${id}`),
  adminAffiliates: () => api.get(`/admin/affiliates`),
  adminAffiliateUpdate: (slug, body) => api.put(`/admin/affiliates/${slug}`, body),
  adminAnalytics: () => api.get(`/admin/analytics`),
};
